/* eslint-disable jsx-a11y/anchor-is-valid */

import {Outlet, Route, Routes} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import {ValueAdds} from './components/ValueAdds'
import {DashboardMiniHeader} from '../newdashboard/DashboardMiniHeader'
import {Policy} from './components/Policy'
import {HelpCenter} from './components/HelpCenter'
import {SocialMediaLinks} from './components/SocialMediaLinks'
import {Suspense} from 'react'
import { Todo } from './components/Todo'

export const DashboardPage: React.FC = () => {
  return (
    <>
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-9'>
          <div className='row g-5 g-xl-8 pr-5'>
            
              <DashboardMiniHeader />
            
          </div>
          <Suspense fallback={<div>Loading...</div>}>
          <Outlet />
          </Suspense>
          
            <Suspense fallback={<div>Loading Value Adds...</div>}>
            <ValueAdds />
            </Suspense>
            
        </div>
        <div className='col-xl-3' style={{paddingRight: 0}}>
          <Suspense fallback={<div>Loading Help Center...</div>}>
            <HelpCenter />
          </Suspense>
          <Suspense fallback={<div>Loading Todo...</div>}>
            <Todo />
          </Suspense>
          <Suspense fallback={<div>Loading Social Media Links...</div>}>
            <SocialMediaLinks />
          </Suspense>
        </div>
      </div>
    </>
  )
}

const DashboardWrapper = () => (
  <Routes>
    {
      <Route
        element={
          <>
            <PageTitle breadcrumbs={[]}>{'Welcome To Futurisk Plus'}</PageTitle>
            <DashboardPage />
          </>
        }
      >
        <Route index element={<Policy />} />
      </Route>
    }
  </Routes>
)

export default DashboardWrapper
